import { render } from "./StyleShort.vue?vue&type=template&id=ea535948&scoped=true"
import script from "./StyleShort.vue?vue&type=script&lang=js"
export * from "./StyleShort.vue?vue&type=script&lang=js"

import "./StyleShort.vue?vue&type=style&index=0&id=ea535948&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea535948"]])

export default __exports__